import React from 'react';
import '../../css/apps.css';
import pwhlFantasyIcon from '../../assets/apps/pwhl-fantasy-icon.jpg';
import throughYourEyesIcon from '../../assets/apps/through-your-eyes-icon.jpg';
import fitCheckIcon from '../../assets/apps/fitcheck-icon.jpg';

// ─── App Store Icon (Apple logo) ─────────────────────────────────────────────
const AppleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 814 1000" fill="currentColor">
    <path d="M788.1 340.9c-5.8 4.5-108.2 62.2-108.2 190.5 0 148.4 130.3 200.9 134.2 202.2-.6 3.2-20.7 71.9-68.7 141.9-42.8 61.6-87.5 123.1-155.5 123.1s-85.5-39.5-164-39.5c-76 0-103.7 40.8-165.9 40.8s-105-37.5-167.2-116.5C158.2 671 124.7 530.9 124.7 395.8c0-207.9 135.5-318 269.1-318 69 0 126.4 44.9 169.3 44.9 41 0 106.9-47.2 183.5-47.2 30.9 0 138.5 2.6 198.3 99.5zm-234-181.5c31.1-36.9 53.1-88.1 53.1-139.3 0-7.1-.6-14.3-1.9-20.1-50.6 1.9-110.8 33.7-147.1 75.8-28.5 32.4-55.1 83.6-55.1 135.5 0 7.8 1.3 15.6 1.9 18.1 3.2.6 8.4 1.3 13.6 1.3 45.4 0 102.5-30.4 135.5-71.3z"/>
  </svg>
);

// ─── App data ─────────────────────────────────────────────────────────────────
// To add icons: import them at the top and set icon: importedImage
const APPS = [
  {
    id: 1,
    name: 'PWHL Fantasy',
    tagline: 'Fantasy Hockey for the Professional Women\'s Hockey League',
    category: 'Sports',
    description: 'The first-ever fantasy hockey app built exclusively for the PWHL. Draft your dream roster from all 8 teams, track live stats, compete in head-to-head leagues, manage your lineup, and follow the latest PWHL news — all in one place. Built by a fan, for fans of women\'s hockey.',
    icon: pwhlFantasyIcon,
    iconEmoji: '🏒',
    appStoreUrl: null,
    comingSoon: true,
    platform: 'iOS',
  },
  {
    id: 2,
    name: 'Through Your Eyes',
    tagline: 'Experience the World Through Different Eyes',
    category: 'Health & Wellness',
    description: 'A real-time vision simulation app that lets you see the world as someone with a visual impairment might. Using Metal GPU shaders and your iPhone camera, Through Your Eyes simulates conditions like myopia, cataracts, glaucoma, and macular degeneration — designed to build empathy and raise awareness.',
    icon: throughYourEyesIcon,
    iconEmoji: '👁️',
    appStoreUrl: null,
    comingSoon: true,
    platform: 'iOS',
  },
  {
    id: 3,
    name: 'FitCheck',
    tagline: 'Your Body. Your Fit. Smarter Shopping.',
    category: 'Lifestyle',
    description: 'FitCheck uses your iPhone\'s LiDAR scanner to create a precise 3D body scan and extract real measurements — chest, waist, hips, inseam, and more. Stop guessing your size. Get clothing recommendations that actually fit, backed by your actual body data.',
    icon: null,
    iconEmoji: '👗',
    appStoreUrl: null,
    comingSoon: true,
    platform: 'iOS',
    note: 'LiDAR required — iPhone 12 Pro+',
  },
];

// ─── Component ───────────────────────────────────────────────────────────────
const Apps = () => {
  return (
    <div className="apps-page">

      {/* Hero */}
      <div className="apps-hero">
        <h1>Our Apps</h1>
        <p>
          We build iOS apps powered by AI and real data. Each one is designed from scratch
          with a focus on speed, simplicity, and doing one thing exceptionally well.
        </p>
      </div>

      {/* Grid */}
      <div className="apps-grid-wrap">
        <div className="apps-grid">
          {APPS.map(app => (
            <div className="app-card" key={app.id}>

              {/* Icon */}
              <div className="app-icon-wrap">
                {app.icon
                  ? <img src={app.icon} alt={`${app.name} icon`} />
                  : <span className="app-icon-placeholder">{app.iconEmoji}</span>
                }
              </div>

              {/* Category */}
              <span className="app-category">{app.category}</span>

              {/* Name */}
              <h3>{app.name}</h3>

              {/* Tagline */}
              <p className="app-tagline">{app.tagline}</p>

              {/* Description */}
              <p>{app.description}</p>

              {/* Platform / note */}
              <p className="app-platform">
                {app.platform}{app.note ? ` · ${app.note}` : ''}
              </p>

              {/* App Store button */}
              {app.comingSoon || !app.appStoreUrl ? (
                <div className="app-store-btn coming-soon">
                  <AppleIcon />
                  <div className="app-store-btn-inner">
                    <span className="app-store-btn-sub">Coming Soon</span>
                    <span className="app-store-btn-label">App Store</span>
                  </div>
                </div>
              ) : (
                <a
                  href={app.appStoreUrl}
                  className="app-store-btn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <AppleIcon />
                  <div className="app-store-btn-inner">
                    <span className="app-store-btn-sub">Download on the</span>
                    <span className="app-store-btn-label">App Store</span>
                  </div>
                </a>
              )}

            </div>
          ))}
        </div>
      </div>

      {/* CTA */}
      <div className="apps-cta">
        <p>
          Have an app idea? We build iOS apps from the ground up, with AI features,
          real-time data, and clean design built in from day one.
        </p>
        <a href="/book-call" className="apps-cta-btn">Talk to Us About Your App →</a>
      </div>

    </div>
  );
};

export default Apps;
